/**
 * @generated SignedSource<<0846812efd27fb357bf6d53de54dd684>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutFooter_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly " $fragmentType": "CheckoutFooter_transaction";
};
export type CheckoutFooter_transaction$key = {
  readonly " $data"?: CheckoutFooter_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFooter_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerChargeCurrency",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "81a40ad093e87923bd4767ca69ea0309";

export default node;
